import * as React from 'react';
import { graphql, ChildProps } from 'react-apollo';
import gql from 'graphql-tag';
import { IUserContext, withUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';
import { CoreGiftCardCreditCards } from '../schemas/rql';
import { mountAdyenSecuredFields, IOnFieldValidData, IOnFocusData, IOnErrorData } from '../credit_cards/adyen_secured_fields';
import SelectableCreditCardListPlaceholder from '../credit_cards/selectable_credit_card_list_placeholder';
import GiftCardCreditCardListItem from './gift_card_credit_card_list_item';

export type Props = ChildProps<IUserContext, CoreGiftCardCreditCards.Query>;

const CARD_COMPONENT_ID = 'credit-cards';
export default function GiftCardCreditCards() {
  // The Adyen Card component requires a DOM element to render the secure fields
  // https://docs.adyen.com/payment-methods/cards/web-component#show-the-available-cards-in-your-payment-form
  return (
    <div id={CARD_COMPONENT_ID}>
      <GiftCardCreditCardListWithData />
    </div>
  );
}

const withQuery = graphql<Props, CoreGiftCardCreditCards.Query>(gql`
query Core_Gift_Card_Credit_Cards {
  me {
    creditCards {
      id
      last4
      cardType
      expirationMonth
      expirationYear
    }
  }
}`,
);

const GiftCardCreditCardListWithData = withUserContext(withQuery(GiftCardCreditCardList));

export function GiftCardCreditCardList(props: Props) {
  const { user } = props;
  const [hasFocus, setFocus] = React.useState(false);
  const [error, setError] = React.useState('');
  const [encryptedCVV, setEncryptedCVV] = React.useState('');
  const [selectedCreditCardId, setSelectedCreditCardId] = React.useState(null);

  function onFieldValid(fieldData: IOnFieldValidData) {
    setEncryptedCVV(fieldData.blob);
  }

  function onFocus(focusData: IOnFocusData) {
    setFocus(focusData.focus);
  }

  function onError(errorData: IOnErrorData) {
    setError(errorData.error);
  }

  React.useEffect(() => {
    mountAdyenSecuredFields({
      domSelector: `#${CARD_COMPONENT_ID}`,
      locale: user.locale,
      onFieldValid,
      onFocus,
      onError,
    });
  });

  if (props.data.loading) {
    return <SelectableCreditCardListPlaceholder />;
  }

  const { creditCards } = props.data.me;
  return (
    <ul>
      <input name="existing_credit_card[tokenized_data][encryptedSecurityCode]" value={encryptedCVV} type="hidden" />
      {creditCards.map(creditCard =>
        <GiftCardCreditCardListItem
          key={creditCard.id}
          creditCard={creditCard}
          onSelect={setSelectedCreditCardId}
          selected={selectedCreditCardId === creditCard.id}
          error={error}
          hasFocus={hasFocus}
        />,
      )}
    </ul>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/gift_card_credit_cards.tsx